
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Auth } from 'aws-amplify'

import { Assessment } from 'utils/types'

import { 
    createSlice, 
    createAsyncThunk, 
    createSelector,
    createEntityAdapter
} from '@reduxjs/toolkit'
 
import { clientBlob } from 'features/client'
// import { Storage } from 'aws-amplify';

import { useAppSelector, useAppDispatch } from 'app/hooks'
import { ThunkAction } from 'redux-thunk'
import { AssessmentPart } from 'API'
import { RootState } from 'app/store'

const assessmentsAdapter = createEntityAdapter<AssessmentPart>({
    selectId: (assessment: AssessmentPart) => assessment.id,
})

const initialState = assessmentsAdapter.getInitialState({
    status: 'idle',
    error: null,
    header: null,
    userContent: [],
    contentName: null,
    contentDate: null,
    assessmentId: null,
    audio: null,
})

export const fetchAudio = createAsyncThunk(
  'assessments/fetchAudio', 
  async (params: {queryStringParameters: {path: string}}) => {
  const {queryStringParameters} = params
  console.log("Query params :",queryStringParameters)
  const response = await clientBlob.get('/audiorequest', 
          {queryStringParameters: queryStringParameters})
  console.log("Audio Fetched :",response)
  return response.data;
})

const assessmentsSlice = createSlice({
    name: 'assessments',
    initialState,
    reducers: {  
    },
    extraReducers(builder) {
      builder
          // fetchAudio
          .addCase(fetchAudio.pending, (state, action) => {
            console.log("fetchAudio: loading ", action)
            // state.status = 'loading'
          })
          .addCase(fetchAudio.fulfilled, (state, action) => {
            console.log("FetchAudio: fulfilled ",action.payload)
            state.audio = action.payload
          })
          .addCase(fetchAudio.rejected, (state, action) => {
            console.log("fetchAudio: failed ", action)
          })
          // AddNewPost
          // .addCase(addNewPost.fulfilled, postsAdapter.addOne)
          // formerly we can directly add the new post object to our posts array
          //state.posts.push(action.payload)
          // now Use the 'addOne' reducer for this case
    }
  })
  
  export const selectAudio = (state: RootState) => state.assessments.audio
  
  export default assessmentsSlice.reducer

    